var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopModal1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "914px",
    height: "672px",
    viewBox: "0 0 914 672",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "boje1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.33282343%",
    y1: "55.4265039%",
    x2: "100%",
    y2: "53.8635329%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8003F5",
    offset: "17.2799128%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D03F5",
    offset: "37.4835928%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D4863",
    offset: "55.5645872%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8003F5",
    offset: "79.7740473%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-22.7%",
    y: "-35.9%",
    width: "145.5%",
    height: "171.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website_2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up_Get-started_1",
    transform: "translate(-263.000000, -190.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "boje",
    filter: "url(#filter-2)",
    x: 390,
    y: 317,
    width: 660,
    height: 418
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopModal1);
export default __webpack_public_path__ + "static/media/desktopModal1.941c45d205fb995366465f352f0adddb.svg";
export { ForwardRef as ReactComponent };